import { render, staticRenderFns } from "./FindNewDeals.vue?vue&type=template&id=3a72df18"
import script from "./FindNewDeals.vue?vue&type=script&lang=js"
export * from "./FindNewDeals.vue?vue&type=script&lang=js"
import style0 from "./FindNewDeals.vue?vue&type=style&index=0&id=3a72df18&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports